/// <reference path="../../Box/Pane.ts" />
namespace HA.Core.HTML.HAList {
    //noinspection TsLint
    export class EntryItem extends Pane {

        protected getModel() {
            const model = this.get("model");
            return this.replaceValues(model);
        }

        protected createSelf() {
            super.createSelf();
            const model = this.getModel();
            try {
                this.createByType(model, this);
            } catch (e) {
                ptime(e);
                log("ooups!");
                throw e;
            }
            this.addClass("ei");
        }
    }

}
